import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { isAuthenticated } from '@/shared/store/auth';

// 로그인 후 돌아갈 URL을 저장하는 검색 파라미터
const loginSearchSchema = z.object({
  redirect: z.string().optional().catch(undefined),
});

/**
 * 로그인 라우트 (/login)
 *
 * beforeLoad 훅을 사용하여 이미 인증된 사용자를 홈으로 리다이렉트합니다.
 * 컴포넌트는 login.lazy.tsx에서 자동으로 코드 스플리팅됩니다.
 *
 * 검색 파라미터:
 * - redirect: 로그인 후 돌아갈 URL (보호된 라우트에서 전달)
 */
export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  beforeLoad: async ({ search }) => {
    if (isAuthenticated()) {
      // 이미 인증된 경우 redirect 파라미터가 있으면 해당 URL로, 없으면 홈으로
      throw redirect({
        to: search.redirect ?? '/',
        replace: true, // 히스토리 대체 - 뒤로가기 시 로그인 페이지 건너뛰기
      });
    }
  },
});
